import { Component, inject, input, output } from '@angular/core';
import { GameComponent, MemorySaveManager, provideLeerplusApi } from '@gametailors/leerplus';
import { IStudioDataPackageProvider } from '@gametailors/lp-studio-connector';
import { RidHomeworkStopCanvasComponent } from './canvas-components/rid-homework-stop-canvas-component/rid-homework-stop-canvas-component';
import { getDefaultCodeSave, LEERPLUS } from './rid-game.utils';

@Component({
  selector: 'rid-game',
  imports: [GameComponent],
  providers: [...provideLeerplusApi()],
  templateUrl: './rid-game.html',
  host: {
    class: 'block size-full',
  },
})
export class RidGame {
  lpapi = inject(LEERPLUS.apiToken);

  mission = input<string>();
  missionCompleted = output<string>();

  studioDataPackageProvider = input.required<IStudioDataPackageProvider>();

  saveManager = new MemorySaveManager(getDefaultCodeSave());
  extension = LEERPLUS.createExtension() //
    .defineCanvasComponent('RidHomeworkStopCanvasComponent', RidHomeworkStopCanvasComponent)
    .build();
}
